export default __webpack_public_path__ + "static/media/finger-guns.5b538971.gif";